/**
 * CONFIGURADOR TREKKO — MODAL DO CARRINHO (Opção B)
 * -------------------------------------------------------------------
 * Abre a personalização completa (Inicial + Nome + Cor) num modal, a
 * partir do bloco "product-list" do carrinho, e adiciona ao carrinho
 * via AJAX — sem tirar o cliente do carrinho e sem recarregar a página.
 *
 * Fonte da verdade das variantes: {{ product.url }}.js buscado em runtime
 * (evita o limite de variantes do Liquid — 182 por produto).
 *
 * Convenção (igual à página do produto):
 *   option1 = cor · option2 = Inicial · Nome = line item property.
 *
 * Cada instância é ESCOPADA ao seu modal (nada de seletores globais),
 * então vários produtos convivem sem conflito.
 */
(function () {
  'use strict';

  var CFG = window.TREKKO_CART_CFG || {};

  function themeRoute(name, fallback) {
    try {
      if (window.theme && window.theme.routes && window.theme.routes[name]) {
        return window.theme.routes[name];
      }
    } catch (e) {}
    return fallback;
  }

  function lockScroll() { document.documentElement.classList.add('ac-modal-open'); }
  function unlockScroll() {
    if (!document.querySelector('.ac-cart-modal.ac-open')) {
      document.documentElement.classList.remove('ac-modal-open');
    }
  }

  function openModal(modal) {
    modal.hidden = false;
    lockScroll();
    /* força reflow para animar a entrada */
    void modal.offsetWidth;
    modal.classList.add('ac-open');
    var first = modal.querySelector('.ac-btn-letra');
    if (first) { try { first.focus(); } catch (e) {} }
  }

  function closeModal(modal) {
    modal.classList.remove('ac-open');
    window.setTimeout(function () {
      modal.hidden = true;
      unlockScroll();
    }, 220);
  }

  function withWidth(src, w) {
    if (!src) return src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  /* Esconde o card do produto recém-adicionado no "Adicione ao seu pedido"
     e, se não sobrar nenhum card, esconde o bloco inteiro. (O bloco não é
     re-renderizado no theme:cart:refresh, então fazemos isso no cliente.) */
  function hideUpsellFor(pid) {
    document.querySelectorAll('[data-ac-open="' + pid + '"]').forEach(function (btn) {
      var card = btn.closest('.product-upsell__holder');
      if (!card) return;
      card.style.display = 'none';

      var widget = card.closest('[data-upsell-widget]');
      if (!widget) return;
      var restantes = widget.querySelectorAll('.product-upsell__holder [data-ac-open]');
      var algumVisivel = false;
      restantes.forEach(function (b) {
        var c = b.closest('.product-upsell__holder');
        if (c && c.style.display !== 'none') algumVisivel = true;
      });
      if (!algumVisivel) widget.style.display = 'none';
    });
  }

  /* Busca as variantes reais do produto uma única vez, por instância. */
  function loadData(cfg) {
    if (cfg._data) return cfg._data;
    cfg._data = fetch(cfg.url + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var variants = {};
        var imgByCor = {};
        (p.variants || []).forEach(function (v) {
          variants[v.option1 + '|' + v.option2] = v.id;
          if (v.option1 && !imgByCor[v.option1]) {
            var img = (v.featured_image && v.featured_image.src) ? v.featured_image.src : (p.featured_image || '');
            if (img) imgByCor[v.option1] = withWidth(img, 720);
          }
        });
        return { variants: variants, imgByCor: imgByCor };
      })
      .catch(function () { return { variants: {}, imgByCor: {} }; });
    return cfg._data;
  }

  function initInstance(modal, cfg) {
    var pid = modal.getAttribute('data-ac-modal');
    var corEm = cfg.corEm === 'nome' ? 'nome' : 'inicial';
    var maxNome = parseInt(cfg.maxNome, 10) || 12;

    var state = { inicial: null, nome: '', cor: null };
    var data = { variants: {}, imgByCor: {} };

    var etapas = modal.querySelectorAll('.ac-etapa');
    var e1 = etapas[0];
    var e2 = etapas[1];
    var preview = modal.querySelector('[data-ac-preview]');
    var addBtn = modal.querySelector('[data-ac-add]');
    var errBox = modal.querySelector('[data-ac-error]');
    var inpNome = modal.querySelector('.ac-input-nome');
    var contador = modal.querySelector('.ac-contador');

    function setHeader(etapa, txt) {
      var el = etapa && etapa.querySelector('.ac-etapa-valor');
      if (el) el.textContent = txt || '';
    }
    function juntar(a, b) { return (a && b) ? (a + ' · ' + b) : (a || b || ''); }

    function e1ok() { if (!state.inicial) return false; return corEm !== 'inicial' || !!state.cor; }
    function e2ok() { if (!state.nome) return false; return corEm !== 'nome' || !!state.cor; }
    function completo() { return e1ok() && e2ok(); }

    function setResumo(key, val) {
      var l = modal.querySelector('[data-resumo="' + key + '"]');
      var v = l && l.querySelector('.ac-resumo-val');
      if (!l || !v) return;
      if (val) { v.textContent = val; l.classList.remove('ac-resumo-pendente'); }
      else { v.textContent = '---'; l.classList.add('ac-resumo-pendente'); }
    }

    function updatePreview() {
      if (!preview || !state.cor) return;
      var img = data.imgByCor[state.cor];
      if (img && preview.getAttribute('src') !== img) preview.src = img;
    }

    function refresh() {
      setHeader(e1, corEm === 'inicial' ? juntar(state.inicial, state.cor) : (state.inicial || ''));
      setHeader(e2, corEm === 'nome' ? juntar(state.nome, state.cor) : (state.nome || ''));

      if (e1ok() && e2) {
        var era = !e2.classList.contains('ac-visivel');
        e2.classList.add('ac-visivel');
        if (era) {
          window.setTimeout(function () {
            try { e2.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); } catch (e) {}
          }, 80);
        }
      }

      setResumo('inicial', state.inicial);
      setResumo('nome', state.nome);
      setResumo('cor', state.cor);
      updatePreview();

      if (addBtn) addBtn.disabled = !completo();
    }

    /* Passo 1 — grade de letras */
    modal.querySelectorAll('.ac-btn-letra').forEach(function (btn) {
      btn.addEventListener('click', function () {
        modal.querySelectorAll('.ac-btn-letra').forEach(function (b) { b.classList.remove('ac-sel'); });
        this.classList.add('ac-sel');
        state.inicial = this.dataset.letra;
        if (e1) e1.classList.remove('ac-destaque');
        refresh();
      });
    });

    /* Swatches (aparecem no passo que o produto definir) */
    modal.querySelectorAll('.ac-swatch').forEach(function (btn) {
      btn.addEventListener('click', function () {
        modal.querySelectorAll('.ac-swatch').forEach(function (b) { b.classList.remove('ac-sel'); });
        this.classList.add('ac-sel');
        state.cor = this.dataset.cor;
        var et = this.closest('.ac-etapa');
        if (et) et.classList.remove('ac-destaque');
        refresh();
      });
    });

    /* Passo 2 — campo de nome (mesma sanitização da página do produto) */
    function pintarContador() {
      if (!contador) return;
      contador.textContent = state.nome.length + '/' + maxNome;
      contador.classList.toggle('ac-cheio', state.nome.length >= maxNome);
    }
    if (inpNome) {
      inpNome.setAttribute('maxlength', maxNome);
      inpNome.addEventListener('input', function () {
        var v = this.value.toUpperCase().replace(/[^A-ZÀ-Ü ]/g, '');
        v = v.replace(/\s{2,}/g, ' ').replace(/^\s+/, '');
        if (v.length > maxNome) v = v.substring(0, maxNome);
        this.value = v;
        state.nome = v.trim();
        var et = this.closest('.ac-etapa');
        if (et) et.classList.remove('ac-destaque');
        pintarContador();
        refresh();
      });
      inpNome.addEventListener('blur', function () {
        this.value = this.value.trim();
        state.nome = this.value;
        pintarContador();
        refresh();
      });
    }

    function showError(msg) { if (errBox) { errBox.textContent = msg; errBox.hidden = false; } }
    function clearError() { if (errBox) { errBox.hidden = true; errBox.textContent = ''; } }

    function destacarFaltando() {
      var faltando = !e1ok() ? e1 : e2;
      if (!faltando) return;
      faltando.classList.add('ac-visivel', 'ac-destaque');
      try { faltando.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
      window.setTimeout(function () { faltando.classList.remove('ac-destaque'); }, 1800);
    }

    function add() {
      if (!completo()) { destacarFaltando(); return; }
      var id = data.variants[state.cor + '|' + state.inicial];
      if (!id) { showError('Combinação indisponível. Tente outra cor ou inicial.'); return; }
      clearError();

      var fd = new FormData();
      fd.append('id', id);
      fd.append('quantity', 1);
      fd.append('properties[Nome]', state.nome);

      addBtn.disabled = true;
      addBtn.classList.add('ac-loading');

      fetch(themeRoute('cart_add_url', '/cart/add.js'), {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
        body: fd
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          addBtn.classList.remove('ac-loading');
          if (res && res.status) {
            showError(res.description || 'Não foi possível adicionar. Tente novamente.');
            addBtn.disabled = false;
            return;
          }
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
          closeModal(modal);
          hideUpsellFor(pid);
          try {
            if (window.theme && window.theme.settings && window.theme.settings.cartType === 'drawer') {
              document.dispatchEvent(new CustomEvent('theme:cart-drawer:open', { bubbles: true }));
            }
          } catch (e) {}
          /* reabilita para uma próxima personalização */
          window.setTimeout(function () { if (addBtn) addBtn.disabled = false; }, 400);
        })
        .catch(function () {
          addBtn.classList.remove('ac-loading');
          addBtn.disabled = false;
          showError('Falha de conexão. Tente novamente.');
        });
    }

    if (addBtn) addBtn.addEventListener('click', add);

    /* Fechar: X, backdrop, Esc */
    modal.querySelectorAll('[data-ac-close]').forEach(function (el) {
      el.addEventListener('click', function () { closeModal(modal); });
    });
    modal.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) closeModal(modal);
    });

    /* Carrega variantes/fotos ao abrir (uma vez) */
    modal.addEventListener('ac:open', function () {
      loadData(cfg).then(function (d) { data = d; updatePreview(); refresh(); });
    });

    /* Estado inicial: só o Passo 1 visível */
    if (e1) e1.classList.add('ac-visivel');
  }

  /* Monta os modais no <body> (evita clipping por transform de ancestral)
     e deduplica por id de produto. */
  document.querySelectorAll('[data-ac-modal]').forEach(function (modal) {
    var pid = modal.getAttribute('data-ac-modal');
    var mounted = document.querySelector('body > [data-ac-modal="' + pid + '"]');
    if (mounted && mounted !== modal) {
      if (modal.parentNode) modal.parentNode.removeChild(modal);
      return;
    }
    if (modal.parentNode !== document.body) document.body.appendChild(modal);
    var cfg = CFG[pid];
    if (cfg) initInstance(modal, cfg);
  });

  /* Abre o modal do produto — via delegação (sobrevive a re-render do carrinho) */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest ? e.target.closest('[data-ac-open]') : null;
    if (!opener) return;
    e.preventDefault();
    var pid = opener.getAttribute('data-ac-open');
    var modal = document.querySelector('body > [data-ac-modal="' + pid + '"]') ||
                document.querySelector('[data-ac-modal="' + pid + '"]');
    if (!modal) return;
    openModal(modal);
    modal.dispatchEvent(new CustomEvent('ac:open'));
  });
})();
